import {ALERT_COMMON_STRINGS} from '../alert-modal';

export const CONFIRM_COMMON_STRINGS = {
    buttonCancel: 'components.alert.button_cancel',
    ...ALERT_COMMON_STRINGS
};
